import { useQuery } from "@tanstack/react-query";
import { getTicketTypes } from "../../api/TICKET/ticketMeta";

export const useTicketTypes = () =>
  useQuery({
    queryKey: ["ticket-types"],
    queryFn: getTicketTypes,
    staleTime: 4 * 60 * 60 * 1000,
  });
